import HeldPayAdjustment from "../../../classes/HeldPayAdjustment";
import { db } from "../../../boot/firebase";
import { addDoc, collection } from "firebase/firestore";

export const LISTEN_HELD_PAY_ADJUSTMENTS = (
  { dispatch },
  { userID, listenerPath, next, error, unlisten } = {}
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: HeldPayAdjustment,
    colGroup: userID ? null : "heldPayAdjustments",
    path: userID ? HeldPayAdjustment.getPath(userID) : null,
    stateKey: "heldPayAdjustments",
    listenerPath,
    next,
    error,
    unlisten,
  });
};

export const SAVE_HELD_PAY_ADJUSTMENT = async (
  { state },
  { adjustment } = {}
) => {
  if (!adjustment) {
    throw new Error("adjustment is required");
  }
  if (adjustment.id) {
    throw new Error("Held pay adjustments are immutable");
  }
  if (!adjustment.isValid) {
    throw new Error("Invalid adjustment");
  }
  adjustment.sanitize();
  adjustment.data.created = new Date();
  adjustment.data.createdBy = state.user.id;
  // balanceBefore / balanceAfter are stamped by the Cloud Function
  // trigger so they reflect the *applied* values (not stale client
  // state). We send null here.
  adjustment.data.balanceBefore = null;
  adjustment.data.balanceAfter = null;

  const ref = await addDoc(
    collection(db, adjustment.path).withConverter(HeldPayAdjustment),
    adjustment
  );
  adjustment.id = ref.id;
  return adjustment;
};
